import React from 'react';
import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';
import { AuthenticatedLayout } from './layouts/AuthenticatedLayout';
import { LoginPage } from './pages/LoginPage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { BoardListPage } from './pages/BoardListPage';
import { BoardViewPage } from './pages/BoardViewPage';
import { CardDetailModal } from './pages/CardDetailModal';
import { NotificationsPage } from './pages/NotificationsPage';
import { ProfilePage } from './pages/ProfilePage';
import { AdminPage } from './pages/AdminPage';
import { CalendarRoute } from './pages/CalendarRoute';
import { PagesRoute } from './pages/pages/PagesRoute';
import { ConceptBrowserPage } from './pages/pages/ConceptBrowserPage';
import { AnalyticsLandingPage } from './pages/AnalyticsLandingPage';
import { DashboardEditorPage } from './pages/DashboardEditorPage';
import { BoardPrepWizard } from './components/analytics/BoardPrepWizard';

/**
 * Application route configuration using React Router v6 data router pattern.
 * 
 * Public routes: /login, /callback
 * Protected routes (require authentication): all others
 * 
 * The AuthenticatedLayout wrapper redirects unauthenticated users to /login
 * while preserving the original URL for post-login redirect.
 */
export const routeConfig: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  { path: '/callback', element: <AuthCallbackPage /> },
  {
    path: '/',
    element: <AuthenticatedLayout />,
    children: [
      { index: true, element: <Navigate to="/boards" replace /> },
      { path: 'boards', element: <BoardListPage /> },
      {
        path: 'boards/:boardId',
        element: <BoardViewPage />,
        children: [
          { path: 'cards/:cardId', element: <CardDetailModal /> },
        ],
      },
      { path: 'boards/:boardId/calendar', element: <CalendarRoute /> },
      { path: 'notifications', element: <NotificationsPage /> },
      { path: 'pages', element: <PagesRoute /> },
      { path: 'pages/concepts', element: <ConceptBrowserPage /> },
      { path: 'pages/:libraryId', element: <PagesRoute /> },
      { path: 'pages/:libraryId/:pageId', element: <PagesRoute /> },
      { path: 'analytics', element: <AnalyticsLandingPage /> },
      { path: 'analytics/wizard', element: <BoardPrepWizard /> },
      { path: 'analytics/dashboards/:dashboardId', element: <DashboardEditorPage /> },
      { path: 'profile', element: <ProfilePage /> },
      { path: 'admin', element: <AdminPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];

export const router = createBrowserRouter(routeConfig);
